import { MeasureData } from "../pt/utils/interfaces";
import { allMeasurementsFitnessMale, allMeasurementsFitnessFemale, allMeasurementsRetailMale, allMeasurementsRetailFemale } from "./constants";

// src/config/domainConfig.ts
export interface KeyLabel {
    key: keyof MeasureData["measurements"],
    label: string,
    unit: string
};
export interface Config {
    isDev: boolean,
    use4views: boolean,
    strings: {
        title: string;
        profile: string;
    },
    measurements: {
        male: KeyLabel[];
        female: KeyLabel[];
    },
    dashboard: {
        tabs: string[];
        defaultTab: string;
    }

}

const configs: Record<string, Config> = {
    "app": {
        isDev: false,
        use4views: false,
        strings: {
            title: "Sizewall Fitness",
            profile: "Client"
        },
        measurements: {
            male: allMeasurementsFitnessMale,
            female: allMeasurementsFitnessFemale
        },
        dashboard: {
            tabs: ["home", "avatar", "trends", "overall"],
            defaultTab: "Avatar"
        }
    },
    "web": {
        isDev: false,
        use4views: false,
        strings: {
            title: "Sizewall",
            profile: "Profile"
        },
        measurements: {
            male: allMeasurementsFitnessMale,
            female: allMeasurementsFitnessFemale
        },
        dashboard: {
            tabs: ["home", "avatar", "trends", "overall"],
            defaultTab: "Avatar"
        }
    },
    "health": {
        isDev: false,
        use4views: false,
        strings: {
            title: "Sizewall",
            profile: "Profile"
        },
        measurements: {
            male: allMeasurementsFitnessMale,
            female: allMeasurementsFitnessFemale
        },
        dashboard: {
            tabs: ["home", "avatar", "trends", "overall"],
            defaultTab: "Avatar"
        }
    },
    "dev": {
        isDev: true,
        use4views: true,
        strings: {
            title: "Sizewall Fitness",
            profile: "Client"
        },
        measurements: {
            male: allMeasurementsFitnessMale,
            female: allMeasurementsFitnessFemale
        },
        dashboard: {
            tabs: ["home", "avatar", "trends", "overall"],
            defaultTab: "Avatar"
        }
    },
    "retail": {
        isDev: false,
        use4views: false,
        strings: {
            title: "Sizewall Retail",
            profile: "Profile"
        },
        measurements: {
            male: allMeasurementsRetailMale,
            female: allMeasurementsRetailFemale
        },
        dashboard: {
            tabs: ["home", "avatar"],
            defaultTab: "avatar"
        }
    },

};

function isLocalDomain(domain: string): boolean {
    return (
        domain === "localhost" ||
        domain.endsWith(".localhost") ||
        domain === "::1" ||
        domain === "[::1]" ||
        domain === "0.0.0.0" ||
        domain.startsWith("127.") ||
        domain.endsWith(".local") ||
        /^10(?:\.\d{1,3}){3}$/.test(domain) ||
        /^172\.(1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2}$/.test(domain) ||
        /^192\.168(?:\.\d{1,3}){2}$/.test(domain) ||
        /^169\.254(?:\.\d{1,3}){2}$/.test(domain)
    );
}

function getCurrentDomainVersion(): string {

    if (typeof window !== "undefined") {
        const domain = window.location.hostname.toLowerCase();
        if (isLocalDomain(domain)) {
            return "dev";
        } else if (domain === "dev.sizewall.com") {
            return "dev";
        } else if (domain === "web.sizewall.com") {
            return "web";
        } else if (domain === "retail.sizewall.com" || domain.includes("retail")) {
            return "retail";
        }
    }
    return "app"; // fallback for SSR or testing
}

export const currentConfig = (() => {
    const domain = getCurrentDomainVersion();
    console.log("Current domain version:", domain);
    return configs[domain] || configs["app"];
})();

export function getConfigForExperience(
    experience?: { measurementDisplay?: string }
): Config {
    const key = experience?.measurementDisplay;
    if (key && Object.hasOwn(configs, key)) {
        return configs[key];
    }
    return currentConfig;
}
